export default __webpack_public_path__ + "static/media/LoopingGIF.3a2df56f.gif";